import * as React from 'react';
import { Text } from 'wix-ui-tpa';
import { classes, st } from './TotalRow.st.css';
import { TotalsDataHook } from '../../Totals';
export var TotalRow = function (_a) {
    var title = _a.title, value = _a.value, className = _a.className, secondaryValue = _a.secondaryValue;
    return (React.createElement("tr", { "data-hook": TotalsDataHook.TotalsRow, className: st(classes.root, className) },
        React.createElement("td", { className: classes.labelTextAlign },
            React.createElement(Text, { className: classes.totalTitleText, "data-hook": TotalsDataHook.TotalsRowTitle }, title)),
        React.createElement("td", { className: classes.textAlign },
            React.createElement(Text, { className: classes.totalTitleValue, "data-hook": TotalsDataHook.TotalsRowValue }, value),
            secondaryValue ? (React.createElement(Text, { className: classes.secondaryValue, "data-hook": TotalsDataHook.TotalsRowSecondaryValue }, " " + secondaryValue)) : null)));
};
TotalRow.displayName = 'Totals.TotalRow';
//# sourceMappingURL=TotalRow.js.map